var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { maxHeight: "100%" } },
    [
      _c(
        "w-card-title",
        [
          _c("w-input", {
            attrs: {
              "has-error": !_vm.descriptionValid,
              placeholder: "Instelling naam",
            },
            model: {
              value: _vm.setting.Description,
              callback: function ($$v) {
                _vm.$set(_vm.setting, "Description", $$v)
              },
              expression: "setting.Description",
            },
          }),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Aantal 1" },
                        model: {
                          value: _vm.setting.Amount1,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "Amount1", $$v)
                          },
                          expression: "setting.Amount1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Aantal 2" },
                        model: {
                          value: _vm.setting.Amount2,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "Amount2", $$v)
                          },
                          expression: "setting.Amount2",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Sku" },
                        model: {
                          value: _vm.setting.ProductSku,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "ProductSku", $$v)
                          },
                          expression: "setting.ProductSku",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Omschrijving" },
                        model: {
                          value: _vm.setting.ProductDescription,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "ProductDescription", $$v)
                          },
                          expression: "setting.ProductDescription",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Eenheidsprijs" },
                        model: {
                          value: _vm.setting.UnitPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "UnitPrice", $$v)
                          },
                          expression: "setting.UnitPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "BTW ID" },
                        model: {
                          value: _vm.setting.VatID,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "VatID", $$v)
                          },
                          expression: "setting.VatID",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Leeggoed" },
                        model: {
                          value: _vm.setting.LeeggoedTax,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "LeeggoedTax", $$v)
                          },
                          expression: "setting.LeeggoedTax",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "Ecobonitax" },
                        model: {
                          value: _vm.setting.EcoboniTax,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "EcoboniTax", $$v)
                          },
                          expression: "setting.EcoboniTax",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: "AccijnzenTax" },
                        model: {
                          value: _vm.setting.AccijnzenTax,
                          callback: function ($$v) {
                            _vm.$set(_vm.setting, "AccijnzenTax", $$v)
                          },
                          expression: "setting.AccijnzenTax",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-card-title", [_vm._v("Functies")]),
          _c(
            "w-list",
            [
              _c(
                "w-list-item",
                [
                  _c("w-list-item-icon"),
                  _c("w-list-item-text", { staticClass: "bold" }, [
                    _vm._v("Functie naam"),
                  ]),
                  _c("w-list-item-text", { staticClass: "bold" }, [
                    _vm._v("Parameters"),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.setting.Funcs, function (func, i) {
                return _c(
                  "w-list-item",
                  { key: func.id },
                  [
                    _c(
                      "w-list-item-icon",
                      [
                        !_vm.isFuncNameValid(func.Name)
                          ? _c("w-fa", {
                              style: { color: "red" },
                              attrs: { icon: "exclamation-circle" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("w-list-item-text", [
                      _c("div", [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: func.Description,
                                expression: "func.Description",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(func.Name))]
                        ),
                      ]),
                    ]),
                    _c("w-list-item-text", [
                      _c(
                        "div",
                        _vm._l(func.Params, function (param) {
                          return _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: param.Description,
                                  expression: "param.Description",
                                },
                              ],
                              key: param.Name,
                              staticClass: "param",
                            },
                            [_vm._v(_vm._s(param.Name))]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.editFunc(func)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleteFunc(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addFunction()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [_vm._v("Functie toevoegen")]),
                ],
                1
              ),
            ],
            2
          ),
          _c("w-card-title", [_vm._v("Geïmporteerde functies")]),
          _c(
            "w-list",
            [
              _c(
                "w-list-item",
                [
                  _c("w-list-item-icon"),
                  _c("w-list-item-text", { staticClass: "bold" }, [
                    _vm._v("Functie naam"),
                  ]),
                  _c("w-list-item-text", { staticClass: "bold" }, [
                    _vm._v("Parameters"),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.setting.SharedFuncList, function (func, i) {
                return _c(
                  "w-list-item",
                  { key: func.FuncID },
                  [
                    _c(
                      "w-list-item-icon",
                      [
                        _c(
                          "w-link",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: func.SharedFunc.Description,
                                expression: "func.SharedFunc.Description",
                              },
                            ],
                          },
                          [_c("w-fa", { attrs: { icon: "info" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-text",
                      [
                        _c("w-input", {
                          attrs: {
                            "has-error": !_vm.isFuncNameValid(func.Alias),
                          },
                          model: {
                            value: func.Alias,
                            callback: function ($$v) {
                              _vm.$set(func, "Alias", $$v)
                            },
                            expression: "func.Alias",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("w-list-item-text", [
                      _c(
                        "div",
                        _vm._l(func.SharedFunc.Params, function (param) {
                          return _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: param.Description,
                                  expression: "param.Description",
                                },
                              ],
                              key: param.Name,
                              staticClass: "param",
                            },
                            [_vm._v(_vm._s(param.Name))]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleteSharedFunc(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addSharedFunction()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [_vm._v("Functie importeren")]),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm.toEditFunc
        ? _c(
            "w-modal",
            { attrs: { value: "", "full-height": "" } },
            [
              _c("app-dossier-auto-sale-row-setting-edit-func", {
                on: {
                  close: function ($event) {
                    _vm.toEditFunc = null
                  },
                },
                model: {
                  value: _vm.toEditFunc,
                  callback: function ($$v) {
                    _vm.toEditFunc = $$v
                  },
                  expression: "toEditFunc",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.addSharedFuncModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "", "full-height": "" } },
            [
              _c("app-dossier-auto-sale-row-setting-add-shared-func", {
                on: {
                  close: function ($event) {
                    _vm.addSharedFuncModalOpen = false
                  },
                },
                model: {
                  value: _vm.setting.SharedFuncList,
                  callback: function ($$v) {
                    _vm.$set(_vm.setting, "SharedFuncList", $$v)
                  },
                  expression: "setting.SharedFuncList",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }